/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';

import { BrandingUiInfoKeys } from '../../../../core/entities';
import { ServicesClientImpl } from '../../../../core/interactors';
import { Locale, LocaleKeys } from '../../../../core/locale';
import { BrandingUiUtility } from '../../../../core/utils';
import { SettingsTemplate } from '../../SettingsTemplate';

import '../../SettingsCommon.scss';
import { KeyManager } from '../../../../core/navigation';

const defaultServices = new ServicesClientImpl();

const TurningParentalOnOff: FunctionComponent = () => {
    const rawText = Locale.getString(LocaleKeys.SETTINGS_HELP_PC_TURNING_ON_OFF);
    const text = BrandingUiUtility.formatDescription(rawText, {
        DEVICE_NAME_SHORT: defaultServices.getBrandingUiInfoForKey(
            BrandingUiInfoKeys.DEVICE_NAME_SHORT,
        ),
    });

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.PC_HELP_SCREEN_TURN_ON_OFF_TITLE)}>
            <div className="settings-common-content text-content">{text}</div>
        </SettingsTemplate>
    );
};

export default TurningParentalOnOff;
